import { Box, Grid, Stack } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

import { RecapCard } from "../../RecapCard";
import { CodeBlock, dracula } from "react-code-blocks";
import { Alert, Typography } from "@mui/material";

export const KdappontLesson2 = () => {
  const recapBlocks = [
    {
      label: "Waar staat HTML voor?",
      image: "presentation-data/KDAPPONT2/intro/html.jpeg",
    },
    {
      label: "Wat is de (technische) rol van een webbrowser?",
      main: (
        <Box
          component="video"
          src="/presentation-data/KDAPPONT2/intro/apple_2.mov"
          autoPlay
          loop
          muted
          sx={{
            width: "100%",
            borderRadius: 2,
            boxShadow: 3,
          }}
        />
      ),
    },
    {
      label: "Ontleedt deze simpele opbouw",
      main: (
        <CodeBlock
          language="html"
          theme={dracula}
          text={`<!DOCTYPE html>
<html>
    <!-- Commentaar regel -->
    <head>
        <title>Document titel</title>
    </head>

    <body>
        <h1>My First Heading</h1>
        <p>My first paragraph.</p>
    </body>
</html>`}
        />
      ),
    },
    {
      label: "Wat is de grootste en belangrijkste koptekst?",
      main: (
        <CodeBlock
          theme={dracula}
          text={`<!DOCTYPE html>
<html>
    <head>
        <title>Document titel</title>							
    </head>

    <body>
        <h6>Title 6</h6>
        <h5>Title 5</h5>
        <h4>Title 4</h4>
        <h3>Title 3</h3>
        <h2>Title 2</h2>
        <h1>Titel 1</h1>
    </body>
</html>`}
          language="html"
        />
      ),
    },
    {
      label: "Is dit geldige HTML?",
      main: (
        <CodeBlock
          theme={dracula}
          text={`<!DOCTYPE html>
<html>
    <head>
        <title>Document titel</title>							
    </head>

    <body>
        <p><strong>Dit is belangrijk</p></strong>
    </body>
</html>`}
          language="html"
        />
      ),
    },
    {
      label: "Wat gebeurt er als ik de </h1> vergeet?",
      main: (
        <CodeBlock
          theme={dracula}
          text={`<!DOCTYPE html>
<html>
    <head>
        <title>Document titel</title>							
    </head>
    <body>
        <h1>Hoofdtitel
        <p>Subtitel</p>
    </body>
</html>`}
          language="html"
        />
      ),
    },
    {
      label: "Met welke bestandsextensie sla je HTML bestanden op?",
      image: "presentation-data/KDAPPONT2/intro/html.jpeg",
    },
    {
      label: "Tags, Attributen & Elementen.",
      main: (
        <>
          Wat is wat?
          <br />
          <br />
          <CodeBlock
            startingLineNumber={1}
            theme={dracula}
            text={`...
<img src="apple.png" alt="Afbeelding van een appel" />
...`}
            language="html"
          />
        </>
      ),
    },
    {
      label: "Hoe gaat een browser om met extra spaties/enters in HTML?",
      main: (
        <CodeBlock
          language="html"
          theme={dracula}
          text={`<!DOCTYPE html>
<html>
    <head>
        <title>Document titel</title>
    </head>

    <body>
        <h1>Deze     heading bevat 
        veel extra      spaties 
        en     enters</h1>
    </body>
</html>`}
        />
      ),
    },
  ];

  const subjectBlocks = [
    {
      label: "Headings",
      main: "Voor titels en subtitels",
    },
    {
      label: "Paragraphs",
      main: "Paragrafen, Horizontal Rules & Line Breaks",
    },
    {
      label: "Comments",
      main: "Helpt je documenteren, maar wordt niet getoond in de webbrowser, wél in de broncode!",
    },
    {
      label: "Text Formatting",
      main: "Underline, bold, italic, marked, etc.",
    },
    {
      label: "Quotations",
      main: "<blockquote> <q> <abbr> <address> <cite> <bdo>",
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🧠 Recap",
          description: ``,
          content: (
            <Stack alignItems="center">
              <Box
                sx={{
                  width: "100%",
                  // "& .swiper-slide": { transition: "filter 300ms ease" },
                  "& .swiper-slide:not(.swiper-slide-active)": {
                    filter: "blur(5px)",
                  },
                  "& .swiper-slide-active,": { filter: "none" },
                }}
              >
                <Swiper
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={3}
                  loop={true}
                  coverflowEffect={{
                    rotate: 20,
                    stretch: 110,
                    depth: 150,
                    modifier: 1.2,
                    slideShadows: false,
                    scale: 0.8,
                  }}
                  pagination={true}
                  navigation={true}
                  modules={[EffectCoverflow, Pagination, Navigation]}
                >
                  {recapBlocks.map((x) => (
                    <SwiperSlide>
                      <Box p={1}>
                        <RecapCard key={x.label} subject={x} />
                      </Box>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Stack>
          ),
        },

        {
          label: "👨🏼‍🏫 Voor vandaag - Les 2",
          description: `Praktijkvoorbeelden`,
          content: (
            <Grid container columns={10} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={2}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },

        {
          label: "🚀 Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 1 :: HTML ➡️ LES 2`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen en opdrachten van Les 1 af en
                laat ze nakijken.
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
